<template>
  <div
    class="tw-mb-3 tw-mr-3 tw-inline-flex tw-h-12 tw-w-48 tw-items-center tw-justify-between tw-rounded tw-border tw-border-dorian-gray-200 tw-bg-white"
  >
    <div
      class="tw-ml-1 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center"
    >
      <ClIconTablerFile :width="'24'" :height="'24'" />
    </div>
    <div class="tw-w-[118px] tw-px-1">
      <div class="tw-w-[118px]">
        <ClTooltip :id="props.name" :text="props.name">
          <span class="tw-text-xs tw-font-bold tw-text-dorian-gray-500">
            {{ truncatedName }}
          </span>
        </ClTooltip>
      </div>
      <div
        class="tw-flex tw-justify-between tw-text-xs tw-text-dorian-gray-500"
      >
        <span>{{ props.extension }}</span>
        <span>{{ props.size }}</span>
      </div>
    </div>
    <div
      class="tw-mr-2 tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-end"
    >
      <a
        :href="props.link"
        :data-test-id="props.testId"
        target="_blank"
        class="tw-text-dorian-gray-500 hover:tw-text-secondary-500"
      >
        <ClIconTablerDownload :width="'18'" :height="'18'" />
      </a>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { ClIconTablerDownload, ClIconTablerFile } from "../icons";
import { ClTooltip } from "../tooltip";

export interface EmailAttachmentProps {
  link: string;
  name: string;
  extension: string;
  size: string;
  testId?: string;
}

const props = withDefaults(defineProps<EmailAttachmentProps>(), {
  testId: "cl-attachment-download-link",
});

const truncatedName = computed(() => `${props.name.substring(0, 16)}...`);
</script>
